// extracted by mini-css-extract-plugin
export default {"HeaderLogo":"HeaderLogo_HeaderLogo__i+zv9","HeaderText":"HeaderLogo_HeaderText__aZReK"};